<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXSBMessagesPeriodicCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.exsbmessagesperiodic.list.noMessages') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('views.exsbmessagesperiodic.form.title') }}</th>
            <th>{{ $t('views.excmmessages.list.status') }}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ item.title }}</td>
            <td>
              <span v-if="item.state === 1">{{$t("views.exsbmessagesperiodic.list.state.on")}}</span>
              <span v-else-if="item.state === 0">{{$t("views.exsbmessagesperiodic.list.state.off")}}</span>
            </td>
            <td>
              <div class="btn-group">
                <router-link
                  tag="button"
                  class="btn btn-link fa fa-edit fa-lg"
                  :to="{ name: 'EXSBMessagesPeriodicUpdate', params: { id: item['@id'] }}"
                ></router-link>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'List',
  components: {
    BaseTableWrapper,
    Pagination,
    Loader
  },

  computed: {
    ...mapGetters({
      error: 'exsbmessagesperiodic/list/error',
      items: 'exsbmessagesperiodic/list/items',
      isLoading: 'exsbmessagesperiodic/list/isLoading',
      view: 'exsbmessagesperiodic/list/view'
    })
  },
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMNotificationMessageList')
  },
  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'exsbmessagesperiodic/list/getItems'
  })
}
</script>

<style scoped>

</style>
